import { Flex, FlexProps } from '@mantine/core';
import styled from 'styled-components';

export const BadgeTextContainer = styled(Flex)<FlexProps>`
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	color: ${({ theme }) => theme.v3.colors.dark[8]};
	padding: 0.25rem;
	border-radius: 12.5rem;

	height: 1.5rem;
	min-height: 1.5rem;
	max-height: 1.5rem;

	width: 1.5rem;
	min-width: 1.5rem;
	max-width: 1.5rem;

	user-select: none;
	cursor: pointer;

	:hover {
		background-color: ${({ theme }) => theme.v3.colors.gray[0]};
	}
`;
